import { MenuItem } from '@mui/material';
import { FC, useMemo } from 'react';
import { useQuery } from 'react-query';
import { IDropdownResponse } from '../../models';
import { SMBSelect } from '../input';
import { getCommonLookupVendors } from '../../fetch/lookups';

interface IVendorDropdownProps {
  value: string | number;
  handleChange: (val: string | number) => void;
  isDisabled?: boolean;
  setOptions?: (val: IDropdownResponse[]) => void;
  hasPunchLists?: boolean;
  isRequired?: boolean;
  inputLabel?: string;
}

export const VendorDropdown: FC<IVendorDropdownProps> = ({
  isDisabled,
  value,
  handleChange,
  isRequired,
  setOptions,
  hasPunchLists,
  inputLabel
}) => {
  const { isLoading: isLoadingVendors, data: vendorData } = useQuery<IDropdownResponse[], Error>(
    ['vendors-filters', hasPunchLists],
    () => getCommonLookupVendors(hasPunchLists),
    {
      onSuccess: d => setOptions?.(d)
    }
  );
  const vendors = useMemo(() => vendorData ?? [], [vendorData]);
  return (
    <SMBSelect
      disabled={isDisabled || isLoadingVendors}
      name={`vendorId`}
      label={isLoadingVendors ? 'Loading...' : inputLabel ?? 'Vendors'}
      required={isRequired}
      value={value}
      variant="outlined"
      handleClear={() => handleChange('')}
      SelectProps={{
        MenuProps: {
          sx: {
            maxHeight: '30rem'
          }
        }
      }}
      onChange={({ target: { value } }) => handleChange(Number(value))}
    >
      {!isLoadingVendors && vendors?.length === 0 && (
        <MenuItem disabled>No data available</MenuItem>
      )}
      {vendors?.map((vendor, index) => {
        return (
          <MenuItem key={`vendor-${vendor.value}`} value={vendor.value}>
            {vendor.description}
          </MenuItem>
        );
      })}
    </SMBSelect>
  );
};
